import React from 'react';

function resolveSrc(record) {
  if (!record) return null;
  if (typeof record === 'string') return record;
  if (record.rawFile && record.rawFile.preview) return record.rawFile.preview;
  if (record.src) return record.src;
  return null;
}

function FlagPreview({ record }) {
  const src = resolveSrc(record);
  if (!src) return null;
  return (
    <img
      src={src}
      alt="bandera"
      style={{
        width: '64px',
        height: '44px',
        objectFit: 'contain',
        border: '1px solid #ccc',
        background: '#fff',
        padding: '2px',
        display: 'block'
      }}
    />
  );
}

export default FlagPreview;
